module.exports = __webpack_public_path__ + "img/sa.5a8d5e3f.svg";